/* Cité Érotik — product form & variant selection Web Component */
(function () {
  'use strict';

  function money(cents) {
    return (window.theme && theme.formatMoney) ? theme.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
  }

  class ProductForm extends HTMLElement {
    connectedCallback() {
      try { this.variants = JSON.parse(this.dataset.variants); } catch (e) { this.variants = []; }
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[data-variant-id]');
      this.priceEl = this.closest('section')?.querySelector('[data-product-price]');
      this.addBtn = this.querySelector('[data-add-to-cart]');
      this.addText = this.querySelector('[data-add-text]');

      this.querySelectorAll('[data-option-input]').forEach((input) => {
        input.addEventListener('change', () => this.onOptionChange());
      });

      // Quantity stepper
      var qtyInput = this.querySelector('[data-qty-input]');
      this.querySelector('[data-qty-decrease]')?.addEventListener('click', () => {
        if (qtyInput) qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      });
      this.querySelector('[data-qty-increase]')?.addEventListener('click', () => {
        if (qtyInput) qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });

      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }

    selectedOptions() {
      var inputs = Array.from(this.querySelectorAll('[data-option-input]:checked'));
      inputs.sort((a, b) => {
        var na = parseInt(a.name.replace('option-', ''), 10);
        var nb = parseInt(b.name.replace('option-', ''), 10);
        return na - nb;
      });
      return inputs.map((i) => i.value);
    }

    onOptionChange() {
      var selected = this.selectedOptions();
      var match = this.variants.find((v) => {
        return [v.option1, v.option2, v.option3].slice(0, selected.length)
          .every((opt, i) => opt === selected[i]);
      });
      this.currentVariant = match;
      this.updateUI(match);
    }

    updateUI(variant) {
      if (!variant) {
        if (this.addBtn) this.addBtn.disabled = true;
        if (this.addText) this.addText.textContent = (window.theme.strings && theme.strings.unavailable) || 'Unavailable';
        return;
      }
      if (this.idInput) this.idInput.value = variant.id;

      // Update URL
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }

      // Price
      if (this.priceEl) {
        var html;
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html = '<div class="flex items-center gap-2 flex-wrap"><span class="text-error font-semibold">' + money(variant.price) + '</span><s class="text-sm text-on-surface-variant">' + money(variant.compare_at_price) + '</s></div>';
        } else {
          html = '<div class="flex items-center gap-2 flex-wrap"><span class="text-on-surface font-semibold">' + money(variant.price) + '</span></div>';
        }
        this.priceEl.innerHTML = html;
      }

      // Availability
      if (this.addBtn) this.addBtn.disabled = !variant.available;
      if (this.addText) {
        this.addText.textContent = variant.available
          ? ((window.theme.strings && theme.strings.addToCart) || 'Add to cart')
          : ((window.theme.strings && theme.strings.soldOut) || 'Sold out');
      }

      // Media gallery switch
      if (variant.featured_media) {
        document.querySelector('media-gallery')?.dispatchEvent(
          new CustomEvent('variant:change', { detail: { mediaId: variant.featured_media.id } })
        );
      }
    }

    async onSubmit(e) {
      e.preventDefault();
      if (!this.addBtn || this.addBtn.disabled) return;
      var original = this.addText ? this.addText.textContent : '';
      if (this.addText) this.addText.textContent = '…';
      this.addBtn.disabled = true;

      try {
        var formData = new FormData(this.form);
        var res = await fetch(window.theme.routes.cartAdd, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        var data = await res.json();
        if (data.status) {
          // error (e.g. sold out)
          if (this.addText) this.addText.textContent = data.description || 'Error';
          setTimeout(() => { if (this.addText) this.addText.textContent = original; this.addBtn.disabled = false; }, 2000);
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:add', { detail: data }));
        if (this.addText) this.addText.textContent = original;
        this.addBtn.disabled = false;
      } catch (err) {
        if (this.addText) this.addText.textContent = original;
        this.addBtn.disabled = false;
      }
    }
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);
})();
